import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { UIRedirectInfo } from '../../Store/UIState';

import {
    Button
} from 'reactstrap';

type Props = {
    redirectInfo?: UIRedirectInfo;
    autoNavToLogin?: boolean;
    style?: React.CSSProperties;
    key?: string;
    buttonText?: string;
    onClick?: () => void;
    containerClass?: string;
    portalLanguage?: string;
}

const LoginButton: React.FC<Props> = (props): React.ReactElement => {
    const { loginWithRedirect } = useAuth0();

    const goLogin = (): void => {
        if (!!props.redirectInfo) {
            let redirectPath = props.redirectInfo.path;

            if (!!props.redirectInfo.searchParams) {
                props.redirectInfo.searchParams.searchParams.forEach((param, index) => {
                    if (index === 0) {
                        redirectPath += '?';
                    } else {
                        redirectPath += '&'
                    }
                    redirectPath += `${param.key}=${param.value}`;
                });
            }

            window.localStorage.setItem(props.redirectInfo.nonce, redirectPath);
        }

        let language = 'en';
        if (!!props.portalLanguage) {
            const languageComponents = props.portalLanguage?.split('-');

            // The most granular level this appears to work with is just the country code, 
            // for example 'es' in 'es-us' which is set here.  Attempts with having the string
            // 'es-us es en' just result in english. Same with 'es-us es'.

            if (languageComponents.length > 1) {
                language = `${languageComponents[0]}`;
            } else {
                language = `${props.portalLanguage}`;
            }
        }

        loginWithRedirect({
            appState: props.redirectInfo,
            ui_locales: language,
        });
    }

    if (props.autoNavToLogin) {
        goLogin();
        return (<></>);
    }

    return (
        <Button
            style={props.style}
            className={`small ${props.containerClass}`}
            onClick={() => { !!props.onClick ? props.onClick() : goLogin() }}
            color="secondary"
        >
            {props.buttonText || 'Log In'}
        </Button>
    )
};

export default LoginButton;
